import classNames from 'classnames/bind';
import React from 'react';

import Link from 'components/shared/link';
import Illustration from 'images/pages/home/ticker/ticker.inline.svg';

import styles from './ticker.module.scss';

const cx = classNames.bind(styles);

const Piece = () => {
  return (
    <>
      <p className={cx('text')}>Sorry, but application is not available now </p>
      <Link className={cx('cta')} to="/">
        READ MORE
      </Link>
      <div className={cx('illustration')}>
        <Illustration />
      </div>
    </>
  );
};

const Ticker = () => {
  return (
    <section className={cx('wrapper')}>
      <div className={cx('inner')}>
        <div className={cx('left')}>
          <Piece />
          <Piece />
          <Piece />
        </div>

        <div className={cx('right')}>
          <Piece />
          <Piece />
          <Piece />
        </div>
      </div>
    </section>
  );
};

export default Ticker;
